document.addEventListener('DOMContentLoaded', function () {
  // -------- SKU Updater -------- //
  function updateSKU(variantId) {
    const spec = window.variantSpecs?.[variantId];
    if (spec && spec.sku !== undefined && spec.sku !== null) {
      const skuEl = document.getElementById('spec-sku');
      if (skuEl) skuEl.textContent = spec.sku;
    }
  }

  const variantSelects = document.querySelector('variant-selects [data-selected-variant]');
  if (variantSelects) {
    try {
      const variantData = JSON.parse(variantSelects.innerHTML);
      if (variantData?.id) updateSKU(variantData.id);
    } catch (e) {
      console.warn("Could not parse selected variant JSON:", e);
    }
  }

  if (window.Shopify && typeof subscribe === "function") {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const variantId = data.variant?.id;
      if (variantId) updateSKU(variantId);
    });
  }

  // -------- 3D Viewer Logic -------- //
  const colorToCodeMap = {
    'Extra Flint': 'BR',
    'Flint': 'FL',
    'Champagne Green': 'CG',
    'Dead Leaf Green': 'DL',
    'Green Auv': 'BR',
    'Amber': 'AM',
    'Antique Green': 'AT',
    'Brown': 'BR',
    'Emerald Green': 'EG',
    'Nordic Blue': 'NB',
    'Georgia Green': 'GG',
    'Cobalt Blue': 'CB',
    'Charcoal': 'CH',
    'Horizon Blue': 'HB',
    'Mist Green': 'MG',
    'Slate Blue': 'SB',
    'Spring Green': 'SG',
    'Sapphire Blue': 'SP',
    'Orchid': 'OR',
    'Frost Blue': 'FB',
    'Arctic Blue': 'BR',
    'Aqua Blue': 'BR',
    'Transition': 'BR',
    'Smoke': 'SM'
  };

  const modal = document.getElementById('modal-3d');
  const iframe = document.getElementById('modal-3d-iframe');
  const closeBtn = document.getElementById('close-3d-modal');
  const openBtn = document.getElementById('open-3d-modal');
  const bicEl = document.querySelector('.bic-value');
  const bic = bicEl ? bicEl.textContent.trim() : null;
  const baseURL = window.agpConfig?.viewerBaseURL;

  function getSelectedColorCode() {
    const checkedSwatch = document.querySelector('.swatch-input__input:checked');
    if (!checkedSwatch) return null;

    const colorName = checkedSwatch.value.trim();
    return colorToCodeMap[colorName] || null;
  }

  function updateIframeSrc(code) {
    if (!bic || !code) {
      console.warn('Missing BIC or color code.');
      return;
    }

    const newSrc = `${baseURL}/${bic}_${code}_XR/${bic}_${code}_XR.html`;

    if (iframe.src !== newSrc) {
      iframe.src = '';
      setTimeout(() => {
        iframe.src = newSrc;
      }, 50);
    }
  }

  // Initial swatch binding
  function bindSwatchListeners() {
    const swatches = document.querySelectorAll('.swatch-input__input');
    swatches.forEach(input => {
      if (!input.dataset.bound) {
        input.dataset.bound = 'true';
        input.addEventListener('change', () => {
          if (input.checked) {
            const code = getSelectedColorCode();
            updateIframeSrc(code);
          }
        });
      }
    });
  }

  bindSwatchListeners();

  const observer = new MutationObserver(bindSwatchListeners);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Modal open/close
  if (openBtn && modal && closeBtn && iframe) {
    openBtn.addEventListener('click', () => {
      const code = getSelectedColorCode();
      updateIframeSrc(code);
      modal.classList.remove('hidden');
    });

    closeBtn.addEventListener('click', () => {
      modal.classList.add('hidden');
      iframe.src = '';
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.classList.add('hidden');
        iframe.src = '';
      }
    });
  }
});






